import React from "react";

const ModuleToggleButton = ({
  title,
  description,
  onClick,
  className,
  active,
}) => {
  const titleSort = title
    .trim()
    .split(" ")
    .filter((word) => word.length > 0)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
  return (
    <button
      className={`cursor-pointer p-3 ${active ? "bg-neutrals-50/70" : ""}`}
      onClick={onClick}
    >
      <div className="flex gap-2.5 items-center mr-2 hover:mr-0 hover:ml-2 transition-all duration-300">
        <div
          className={`w-10 h-10 rounded-sm bg-primary text-white font-medium flex items-center justify-center p-1 ${className}`}
        >
          {titleSort}
        </div>
        <div className="flex flex-col justify-center gap-0.5">
          <h6 className="text-left whitespace-nowrap">{title}</h6>
          <div className="flex gap-0.5 items-end">
            <span>
              <svg
                width="15"
                height="15"
                viewBox="0 0 45 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27 45C26.4477 45 26 44.5523 26 44V29C26 28.4477 26.4477 28 27 28H31C31.5523 28 32 28.4477 32 29V44C32 44.5523 31.5523 45 31 45H27Z"
                  fill="#514F4F"
                />
                <path
                  d="M14.3558 19.0801C14.778 19.0801 15.1548 19.3453 15.2972 19.7427L23.8686 43.6627C24.102 44.3141 23.6192 45 22.9272 45H19.3126C18.8804 45 18.497 44.7222 18.3624 44.3115L16.9378 39.9649C16.8031 39.5541 16.4198 39.2764 15.9875 39.2764H7.69549C7.26367 39.2764 6.88062 39.5536 6.74562 39.9637L5.31429 44.3126C5.17929 44.7228 4.79624 45 4.36442 45H1.00085C0.30887 45 -0.173963 44.3141 0.0594647 43.6627L8.63088 19.7427C8.77331 19.3453 9.15004 19.0801 9.57226 19.0801H14.3558ZM8.82661 33.6435C8.61377 34.2903 9.09557 34.9561 9.77651 34.9561H13.9158C14.5963 34.9561 15.0781 34.2911 14.8661 33.6445L12.8002 27.3433C12.4994 26.4258 11.2019 26.4251 10.9001 27.3422L8.82661 33.6435Z"
                  fill="#514F4F"
                />
                <path
                  d="M28.3298 15.2755C28.408 15.1489 28.592 15.1489 28.6702 15.2755L30.1934 17.7415C30.2098 17.768 30.232 17.7902 30.2585 17.8066L32.7245 19.3298C32.8511 19.408 32.8511 19.592 32.7245 19.6702L30.2585 21.1934C30.232 21.2098 30.2098 21.232 30.1934 21.2585L28.6702 23.7245C28.592 23.8511 28.408 23.8511 28.3298 23.7245L26.8066 21.2585C26.7902 21.232 26.768 21.2098 26.7415 21.1934L24.2755 19.6702C24.1489 19.592 24.1489 19.408 24.2755 19.3298L26.7415 17.8066C26.768 17.7902 26.7902 17.768 26.8066 17.7415L28.3298 15.2755Z"
                  fill="#514F4F"
                />
                <path
                  d="M37.3298 0.275467C37.408 0.148941 37.592 0.148941 37.6702 0.275467L40.3389 4.596C40.3553 4.62245 40.3776 4.64472 40.404 4.66106L44.7245 7.32984C44.8511 7.408 44.8511 7.592 44.7245 7.67016L40.404 10.3389C40.3776 10.3553 40.3553 10.3776 40.3389 10.404L37.6702 14.7245C37.592 14.8511 37.408 14.8511 37.3298 14.7245L34.6611 10.404C34.6447 10.3776 34.6224 10.3553 34.596 10.3389L30.2755 7.67016C30.1489 7.592 30.1489 7.408 30.2755 7.32984L34.596 4.66106C34.6224 4.64472 34.6447 4.62245 34.6611 4.59601L37.3298 0.275467Z"
                  fill="#514F4F"
                />
                <path
                  d="M22.8298 6.27547C22.908 6.14894 23.092 6.14894 23.1702 6.27547L24.8843 9.0506C24.9007 9.07704 24.923 9.09932 24.9494 9.11565L27.7245 10.8298C27.8511 10.908 27.8511 11.092 27.7245 11.1702L24.9494 12.8843C24.923 12.9007 24.9007 12.923 24.8843 12.9494L23.1702 15.7245C23.092 15.8511 22.908 15.8511 22.8298 15.7245L21.1157 12.9494C21.0993 12.923 21.077 12.9007 21.0506 12.8843L18.2755 11.1702C18.1489 11.092 18.1489 10.908 18.2755 10.8298L21.0506 9.11565C21.077 9.09932 21.0993 9.07704 21.1157 9.0506L22.8298 6.27547Z"
                  fill="#514F4F"
                />
              </svg>
            </span>
            <p className="card-label-small text-left  whitespace-nowrap">
              {description}
            </p>
          </div>
        </div>
      </div>
    </button>
  );
};

export default ModuleToggleButton;
